
/**
 * 플랫폼 지원
 */
export type GetCourseDraftById200LocalizedSectionsItemLecturesItemPlatformSupport = typeof GetCourseDraftById200LocalizedSectionsItemLecturesItemPlatformSupport[keyof typeof GetCourseDraftById200LocalizedSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200LocalizedSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
